// extracted by mini-css-extract-plugin
module.exports = {"body":"InputBlock_body__39kB0","input":"InputBlock_input___R2cy","go":"InputBlock_go__3Agor"};